// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ehJU","importantInfo":"styles_importantInfo__2N6Av"};